import React from "react";
import { Link } from "react-router-dom";

export const LinkButton = ({
  children,
  className = "",
  compact = false,
  title = "",
  to,
}: {
  children: React.ReactNode;
  className?: string;
  to: string;
  compact?: boolean;
  title?: string;
}) => (
  <Link
    title={title}
    className={`${className} whitespace-no-wrap cursor-pointer flex bg-blue-500 hover:bg-blue-700 text-white font-bold ${
      compact ? "py-1 px-2" : "py-2 px-4"
    } rounded focus:outline-none focus:shadow-outline`}
    to={to}
  >
    {children}
  </Link>
);
